import { postRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function newDeviationCauseRequest(deviationCause) {
	let url = maintenance.getDeviationCausesPath();
	let response = await postRequest(url, {}, deviationCause);
	return response;
}